import { fonts, dims, colors } from '../../../../../styles'

export const defaultStyle = {
	fontFamily: fonts.paragraph,
	fontSize: 14,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	color: colors.lightGrey,
	width: 100,
	height: dims.nav
}

export const activeStyle = {
	...defaultStyle,
	fontFamily: fonts.header,
	color: colors.white,
	textDecoration: 'underline'
}



// WEBPACK FOOTER //
// ./src/components/Layout/nav/DesktopNav/Tab/styles.js